import { QueryClient } from "@tanstack/react-query";

export const queryOptions = {
  retry: 0,
  refetchOnWindowFocus: false,
};

export const queryClient = new QueryClient({ defaultOptions: { queries: queryOptions } });
